import EventsApi from "./events";

export default { 
    ...EventsApi
 };